import {observable,action} from 'mobx'
import {getVal,setVal,deleteVal} from '../../utils/server'

class MetricStore{
  @observable metrics = getVal("metricsName",[])
  @observable addLogMetricInfo = getVal("addLogMetric",{
    "metricName":"",
    "query":"",
    "recentTime": 300,
    "symbol":'notSet',
    "comment": "",
    "project": "",
    "logStore": "",
    "interval": 60,
    "keyWord": null,
    "ignoreWord":null,
  })
  @observable addDbMetricInfo = getVal("addDbMetric",{
    "name": "",
    "sql": "",
    "comment": "",
    "host": "",
    "port": 3306,
    "database": "",
    "username": "",
    "password": "",
    "keyWord": null,
    "ignoreWord":null,
    "type":"mysql",
    "interval": 60,
    "keepHistory": 1
  })
  @observable editMetricInfo = getVal("editMetric",{"metricName":"","type":""})
  @observable checkMetricInfo = getVal("checkMetric",{"metricName":"","type":""})
  @observable checkDetailMetricInfo = getVal("checkDetailMetric","")
  @observable metricInfo = getVal("metric",{})
  @observable from = getVal("from","/home/alerts/rules")
  @observable addUserInfo = getVal("userInfo", {"id":"", "name":""})

  @action setUserInfo(userInfo) {
    this.userInfo = userInfo
    setVal("userInfo", this.userInfo)
  }

  @action setMetrics(metrics){
    this.metrics= metrics
    setVal("metricsName",this.metrics)
  }
  @action setAddLogMetricInfo(info){
    this.addLogMetricInfo= info
    setVal("addLogMetric",this.addLogMetricInfo)
  }
  @action setAddDbMetricInfo(info){
    this.addDbMetricInfo = info
    setVal("addDbMetric",this.addDbMetricInfo)
  }
  @action setEditMetricInfo(metricName,type){
    this.editMetricInfo = {"metricName":metricName,"type":type}
    setVal("editMetric",this.editMetricInfo)
  }
  @action setCheckMetricInfo(metricName,type){
    this.checkMetricInfo = {"metricName":metricName,"type":type}
    setVal("checkMetric",this.checkMetricInfo)
  }
  @action setCheckDetailMetricInfo(metricName){
    this.checkDetailMetricInfo = metricName
    setVal("checkDetailMetric",this.checkDetailMetricInfo)
  }
  @action setMetricInfo(metricInfo){
    this.metricInfo= metricInfo
    setVal("metric",this.metricInfo)
  }
  @action setFrom(from){
    this.from= from
    setVal("from",this.from)
  }

  @action deleteLogMetricAddInfo(){
    deleteVal("addLogMetric")
  }
  @action deleteDbMetricAddInfo(){
    deleteVal("addDbMetric")
  }
  @action deleteMetricEditInfo(){
    deleteVal("editMetric")
  }
  @action deleteMetricCheckInfo(){
    deleteVal("checkMetric")
  }
}

export default new MetricStore()


// WEBPACK FOOTER //
// ./src/routes/Metrics/store.js